module.exports = __webpack_public_path__ + "img/banner_left.5aad12b0.png";